<template>
  <FormattedMessage class="caption" :definition="translations.termsDescription">
    <template #faqLink>
      <RevLink
        class="caption"
        target="_blank"
        :to="i18n(translations.faqLinkValue)"
        :tracking="{
          name: 'terms_document',
          zone: 'cart_insurance_selected',
        }"
      >
        {{ i18n(translations.faqLinkLabel) }}
      </RevLink>
    </template>
  </FormattedMessage>

  <RevLink
    v-if="termsUrl"
    class="block caption-link"
    target="_blank"
    :to="termsUrl"
    :tracking="{
      name: 'terms_document',
      zone: 'cart_insurance_selected',
    }"
  >
    {{ i18n(translations.termsLinkContent) }}
  </RevLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { InsuranceOfferCompliancyDocument } from '@backmarket/http-api/src/api-models/InsuranceOfferCompliancyDocument'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import { DOCUMENT_KINDS } from '../../constant'

import translations from './BienniallyTerms.translations'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{ documents: InsuranceOfferCompliancyDocument[] }>(),
  { documents: () => [] },
)

const termsUrl = computed(
  () =>
    props.documents.find(
      (doc) => doc.kind === DOCUMENT_KINDS.TERMS_AND_CONDITIONS,
    )?.url,
)
</script>
